import React, { FC } from 'react';
import { Button, LinkButton, Modal } from 'src/components';
import { IconName } from '../Icon';
import * as S from './styles';

export const ActionsPopup: FC<{
  header: string;
  text?: string;
  primaryBtnText: string;
  primaryBtnAction?: () => void;
  primaryHref?: string;
  primaryBtnIcon?: IconName;
  secondaryBtnText?: string;
  secondaryBtnAction?: () => void;
  secondaryBtnIcon?: IconName;
  isOpen: boolean;
  onClose: () => void;
}> = ({
  header,
  text,
  primaryBtnText,
  primaryBtnAction,
  primaryHref,
  primaryBtnIcon,
  secondaryBtnText,
  secondaryBtnAction,
  secondaryBtnIcon,
  isOpen,
  onClose,
}) => {
  return (
    <Modal darkCloseIcon handleClose={onClose} shouldCloseOnEsc isOpen={isOpen}>
      <S.ModalContent>
        <S.ModalHeader data-testid="ActionsPopup-header">{header}</S.ModalHeader>
        {text && <S.TextWrapper>{text}</S.TextWrapper>}
        <S.ButtonsWrapper $isFlexEnd={!secondaryBtnText}>
          {secondaryBtnText && secondaryBtnAction && (
            <Button
              buttonSize="medium"
              buttonType="secondary"
              wide
              onClick={secondaryBtnAction}
              icon={secondaryBtnIcon}
            >
              {secondaryBtnText}
            </Button>
          )}
          {primaryHref ? (
            <LinkButton
              buttonSize="medium"
              buttonType="primary"
              wide
              href={primaryHref}
              icon={primaryBtnIcon}
              onClick={primaryBtnAction}
            >
              {primaryBtnText}
            </LinkButton>
          ) : (
            <Button
              buttonSize="medium"
              buttonType="primary"
              wide
              icon={primaryBtnIcon}
              onClick={primaryBtnAction}
            >
              {primaryBtnText}
            </Button>
          )}
        </S.ButtonsWrapper>
      </S.ModalContent>
    </Modal>
  );
};
